import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TnbUser } from '../../service/auth/tnb-user';
import { TeilgebietSelectionService } from '../../service/common/teilgebiet/teilgebiet-selection.service';
import { PlanwertFilter } from '../../service/planwert/planwert-filter';
import { DashboardInfoContainer } from '../../domain/model/dashboard-info-container.model';
import { DashboardInfoService } from '../../service/dashboard/dashboard-info.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'redispatch-dashboard-page',
    templateUrl: './dashboard-page.component.html',
    styleUrls: [
        './dashboard-page.component.scss',
    ],
    standalone: false,
})
export class DashboardPageComponent implements OnInit {

    public tnbUser: TnbUser;

    public dashboardInfo = signal<DashboardInfoContainer>({
        erzeugungsanlage: null,
        netzzuordnung: null,
        planwerte: null,
        netzzuordungImport: null,
        unbestaetigteUuids: null,
        dienstleistungsarten: null,
    });

    public dashboardInfoStatus = signal<'PENDING' | 'SUCCESS' | 'ERROR'>('PENDING');

    public isAdmin: boolean;

    public isStadtwerk: boolean;
    selectedStadtwerkId: string;
    private route = inject(ActivatedRoute);
    private teilgebietSelectionService = inject(TeilgebietSelectionService);
    private dashboardInfoService = inject(DashboardInfoService);
    private destroyRef = inject(DestroyRef);

    constructor() {
        this.tnbUser = this.route.snapshot.data.profile;
        this.selectedStadtwerkId = this.teilgebietSelectionService.getSelectedStadtwerkeId();
        this.isStadtwerk = this.tnbUser.netzbetreiberType === 'STADTWERK';
        this.isAdmin = this.tnbUser.netzbetreiberType === 'WESTNETZ';
    }

    getPlanwerteFilter() {
        return { stadtwerkeId: this.selectedStadtwerkId } as PlanwertFilter;
    }

    ngOnInit() {
        this.dashboardInfoService.getDashboardInfo(this.tnbUser, this.selectedStadtwerkId, this.getPlanwerteFilter()).pipe(
            takeUntilDestroyed(this.destroyRef),
        ).subscribe({
            next: (value) => {
                this.dashboardInfo.set(value);
                this.dashboardInfoStatus.set('SUCCESS');
            }, error: (_) => {
                this.dashboardInfoStatus.set('ERROR');
            },
        });
    }
}
